export const question = [
    {
      id: 1,
      question: "Eligibility",
      answer: [
        {
          item: "Registered business operating for at least 2 years",
        }
      ],
    },
    {
      id: 2,
      question: "Purpose",
      answer: [
        {
          item: "Overdraft working capital requirement.",
        },
        {
          item: "Non-Fund based Facilities (Letters of Credit and Bank Guarantees)",
        },
      ],
    },
    {
      id: 3,
      question: "Security",
      answer: [
        {
          item: "Legal mortgage over property offered",
        },
      ],
    },
    {
      id: 4,
      question: "Repayment Period",
      answer: [
        {
          item: "12 months subject to renew",
        },
      ],
    }
  ];